<script setup lang="ts">
    import Login from "@/components/auth/forms/Login.vue";
    import useLiveChat from "@/helpers/composables/useLiveChat";
    import { Link, usePage } from "@inertiajs/vue3";
    import { inject, computed } from "vue";
    import LoginIssueIcon from "@icons/issue_login_icon.svg";
    let route = inject("route");

    const { openLiveChat } = useLiveChat();

    let message = computed(() => {
        return usePage()?.props?.flash?.message ?? {
            type: null,
        };
    });
</script>

<template>
    <div>
    <div style="margin-bottom: 1rem;" v-if="message.type" :class="
    {
        'notification': true,
        'notification-success': message.type == 'success',
    }">
        <p class="paragraph-details">{{ message.message }}</p>
    </div>
    <Login />
    <Link :href="route('web.forgot-password')" class="navigation authorization-forgot_password"
        >Forgot password</Link>
        <div class="authorization-issue_link">
            <LoginIssueIcon alt="issue icon" />
            <div class="authorization-issue_text paragraph-details">
                <span class="authorization-issue_link_span">Issues Logging In?</span> <a @click.prevent="openLiveChat({sessionStarted: true})" href="#" class="authorization-troubleshooting_link paragraph-details">Contact us for support</a>
            </div>
        </div>
    </div>
</template>

<style scoped></style>
